import { get, isArray } from 'lodash';
import React from 'react';
import { TreeNodeType } from 'src/lib/types/types';

// import Schemas
import AntragSchema from 'src/lib/paths/antrag_FULL_Paths.json';
import ErklaerungMA, { getFormStrucErklaerungMA } from './content/ErklaerungMA';
const P = AntragSchema.attributes;

export const TreeStructureErklaerungMA = (application: any) => {
	const hasValidErklaerung = (erklaerungen: any[]) => {
		if (isArray(erklaerungen) && erklaerungen.length > 0) {
			return erklaerungen.some((ele) => get(ele, 'Inhalt', '').trim() !== '');
		} else {
			return false;
		}
	};

	let treeNodes: TreeNodeType[] = [];

	const pflichtErklaerungen = get(application, P.Erklaerungen_Pflichterklaerungen.path, []);
	const optionaleErklaerungen = get(application, P.Erklaerungen_Optionale_Erklaerungen.path, []);

	if (hasValidErklaerung(pflichtErklaerungen) || hasValidErklaerung(optionaleErklaerungen)) {
		treeNodes = [
			{
				label: 'Erklärungen',
				content: <ErklaerungMA />,
				formStruc: getFormStrucErklaerungMA(application),
			},
		];
	}

	return treeNodes;
};
